(ns frontend.state.current-settings
  (:require
   [frontend.state.permissions :as f-permissions]
   [common.schema.registry :as registry]
   [common.schema.field-spec :as field-spec]
   [frontend.state.current-session :as session]
   [frontend.tenant-customizations :as tenant-customizations]
   [frontend.view.modals.entity.attributes :as attributes]))

(defn mandatory-fields
  [{:keys [entity-type default-mandatory-fields selected-pipeline-id]}]
  ;; TODO: tenant/entity stage etc. specific settings to be used to control mandatory fields here (state is used to read current stage etc.) ;
  (let [optional-pipeline-id
        (or selected-pipeline-id
            (case entity-type
              :entity.type/oppo @session/selected-oppo-pipeline
              :entity.type/fundraising-opportunity @session/selected-froppo-pipeline
              :entity.type/sales-opportunity @session/selected-sales-oppo-pipeline
              :entity.type/exit-opportunity @session/selected-exit-oppo-pipeline
              nil))
        f-log? (tenant-customizations/f-log?)
        tesi? (tenant-customizations/tesi?)
        capman? (tenant-customizations/capman?)
        capman-re? (tenant-customizations/capman-is-real-estate-pipeline? optional-pipeline-id)
        demo-test2? (tenant-customizations/demo-test2-oppo-pipeline? optional-pipeline-id)
        united-bankers? (tenant-customizations/united-bankers?)
        voima-ventures? (tenant-customizations/voima-ventures?)
        mandatory-fields
        (concat
         (->> (registry/get-schema @session/tenant-schema entity-type)
              (filter (fn [[_k fs]]
                        (or (and (field-spec/system-required-field? fs)
                                 (not (field-spec/system-only-field? fs)))
                            (field-spec/legacy-always-mandatory-field? fs {}))))
              (sort-by (fn [[_k fs]]
                         (:field/default-ord fs)))
              (keys))
         (case entity-type
           :entity.type/company (cond
                                  f-log?
                                  [:asset/description :company/website :asset/country
                                   :asset/city
                                   :company/tag-tags :company/company-owner]
                                  tesi?
                                  [:asset/name :company/business-id :asset/description
                                   :company/tesi-main-industry-usual-suspects
                                   :company/tag-tags :asset/country]
                                  :else
                                  [:asset/name])
           :entity.type/oppo
           (cond
             f-log?
             [:oppo/status-and-next-steps
              :oppo/deal-description
              :oppo/funding-round-v2
              :oppo/lead-source-v2
              :oppo/lead-source-comment]
             tesi?
             [:oppo/name :oppo/case-note :oppo/investment-stage :oppo/opt-17592200887814-initial :oppo/opt-17592200887814-investor]
             capman-re?
             [:oppo/name :oppo/owner :oppo/tag-country]
             demo-test2?
             [:oppo/name :oppo/owner :oppo/tag-country]
             voima-ventures?
             attributes/voima-mandatory-deal-attrs
             :else
             [:oppo/name :oppo/lead-source-v2 :oppo/owner])
           :entity.type/fundraising-opportunity
           (cond capman?
                 [:fundraising-opportunity/opportunity-name
                  :fundraising-opportunity/investor
                  :fundraising-opportunity/opportunity-stage]
                 :else
                 [:fundraising-opportunity/opportunity-name
                  :fundraising-opportunity/opportunity-stage])
           :entity.type/exit-opportunity
           [:exit-opportunity/name
            :exit-opportunity/stage
            :exit-opportunity/status
            :exit-opportunity/owner]
           :entity.type/fund-commitment
           (cond united-bankers?
                 [:fund-commitment/investor :fund-commitment/cur-committed-amount
                  :fund-commitment/cur-committed-amount--sym]
                 :else
                 [:fund-commitment/investor :fund-commitment/cur-committed-amount
                  :fund-commitment/cur-committed-amount--sym :fund-commitment/closing-information])
           :entity.type/real-estate (cond capman?
                                          [:asset/name :real-estate/property-type
                                           :real-estate/lettable-area :asset/street-address
                                           :asset/city :asset/country]
                                          :else
                                          [:asset/name])
           :entity.type/other-asset [:asset/name]
           :entity.type/holding (cond tesi?
                                      [:holding/name
                                       :holding/owner
                                       :holding/target-asset
                                       :holding/tag-tags]
                                      :else
                                      [:holding/name :holding/owner :holding/target-asset])
           :entity.type/investor (cond tesi?
                                       [:investor/name
                                        :investor/description
                                        :investor/investor-types]
                                       :else
                                       [])
           :entity.type/sale-agreement (cond
                                         capman?
                                         [:sale-agreement/contract-status]
                                         :else
                                         [])
           [])
         default-mandatory-fields)
        in-use-mandatory-fields
        (->> mandatory-fields
             (distinct)
             (filter
              (fn [attribute]
                (f-permissions/field-write-access? attribute entity-type optional-pipeline-id)))
             (doall))]
    in-use-mandatory-fields))
